import ActionIcon from '@/components/_common/ActionIcon';
import { usePurchaseItemCreatePart } from '@/core/domain/purchase/purchaseItem/PurchaseItem.hooks';
import { PurchaseItem } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { Divider, Modal, Tooltip } from 'antd';
import { Plus } from 'react-feather';

interface Props {
  purchaseItem: PurchaseItem;
}

export default function PurchaseItemCreatePart({ purchaseItem }: Props) {
  const purchaseItemCreatePart = usePurchaseItemCreatePart();

  const handleCreatePart = async () => {
    Modal.confirm({
      title: 'Cadastrar peça no estoque e vincular',
      width: 600,
      content: (
        <p>
          Deseja cadastrar o item da compra{' '}
          <strong>"{purchaseItem.name}"</strong> como peça no estoque e vincular
          ao item?
        </p>
      ),
      okText: 'Cadastrar & Vincular',
      onOk: () => purchaseItemCreatePart.mutateAsync(purchaseItem.id),
    });
  };

  return (
    <>
      <Tooltip title="Cadastrar Peça">
        <ActionIcon onClick={handleCreatePart}>
          <Plus size={20} />
        </ActionIcon>
      </Tooltip>

      <Divider style={{ margin: 0 }} type="vertical" />
    </>
  );
}
